import Page from "./questions";
export default Page;
